import { Link } from "react-router-dom"
import { Compass } from "lucide-react"
import { Button, EmptyState } from "../components/ui"

export function NotFoundPage() {
	return (
		<div className="py-16">
			<EmptyState
				icon={Compass}
				title="Nothing here"
				description="That project or issue does not exist, or the link has gone stale."
				action={
					<Button as={Link} to="/app" variant="primary">
						Back to the dashboard
					</Button>
				}
			/>
		</div>
	)
}
